// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCustomerRequestModel from '../../model/get-customer-request-model';
import GetCustomerRequestDTO from '../dto/get-customer-request-dto';

export default abstract class GetCustomerRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCustomerRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetCustomerRequestDTO>): GetCustomerRequestModel;
  static toModel(dto: DeepPartial<GetCustomerRequestDTO> | undefined | null): GetCustomerRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCustomerRequestDTO> | undefined | null): GetCustomerRequestModel | undefined {
    return dto ? new GetCustomerRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCustomerRequestModel> | GetCustomerRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetCustomerRequestDTO;
  }
}
